var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v(" 結果概要 ")]),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(ref){
var ref_item = ref.item;
var score = ref_item.score;
var selfs = ref_item.selfs;
var category = ref_item.category;
var meanScore = ref_item.meanScore;
var diffSelfAndmeanScore = ref_item.diffSelfAndmeanScore;
var sdScore = ref_item.sdScore;
var frequency = ref_item.frequency;
var index = ref.index;
return [_c('tr',[_c('td',[_vm._v(_vm._s(category))]),_c('td',[_vm._v(_vm._s(selfs))]),_c('td',[_vm._v(_vm._s(meanScore))]),_c('td',[_vm._v(_vm._s(diffSelfAndmeanScore))]),_c('td',[_vm._v(_vm._s(sdScore))])])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }